import { render, staticRenderFns } from "./SimpleRadioButton.vue?vue&type=template&id=57d3f7ef&"
import script from "./SimpleRadioButton.vue?vue&type=script&lang=ts&"
export * from "./SimpleRadioButton.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleRadioButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports